"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.TransactionBuildBody = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var ui_common_1 = require("@codametrix/ui-common");
var can_drop_1 = require("./can-drop");
var ui_components_1 = require("@codametrix/ui-components");
var conditional_1 = require("../../conditional/conditional");
var draggedCodesManager = ui_common_1.dragManager.load('codes');
/**
 * React component that displays a build body
 * @param codableTransaction
 * @param onDropHandler
 * @param onAccordionAction
 * @param items
 * @param onDelete
 * @param editable
 * @returns
 */
var TransactionBuildBody = function (codableTransaction, onDropHandler, onAccordionAction, items, onDelete, editable) {
    var _a, _b;
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "transaction-bodyV2" }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: "charge-details-header-section" }, { children: [(0, jsx_runtime_1.jsx)("h5", { children: "Charge details" }), (0, jsx_runtime_1.jsx)(conditional_1.Conditional, __assign({ on: editable }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: "charge-delete-section", onClick: function (e) { return onDelete(e); } }, { children: (0, jsx_runtime_1.jsx)(ui_components_1.Icon, { svgIconName: "BiomeDelete", svgIconSize: "20", svgIconClass: "action-icon delete-icon" }) })) }))] })), (0, jsx_runtime_1.jsx)("div", { children: items.length ? ((0, jsx_runtime_1.jsx)(ui_components_1.Accordion, { onAction: onAccordionAction, dragManager: draggedCodesManager, canDropOnto: can_drop_1.canDropOnto, onDropHandler: onDropHandler, selectable: true, droppable: true, items: items, errors: (_b = (_a = codableTransaction === null || codableTransaction === void 0 ? void 0 : codableTransaction.procedure) === null || _a === void 0 ? void 0 : _a.errorMessages) !== null && _b !== void 0 ? _b : [] })) : editable ? ((0, jsx_runtime_1.jsx)("div", __assign({ className: "empty-message editable" }, { children: "Add codes in the above section." }))) : ((0, jsx_runtime_1.jsx)("div", __assign({ className: "empty-message uneditable" }, { children: "No codes selected" }))) })] })));
};
exports.TransactionBuildBody = TransactionBuildBody;
//# sourceMappingURL=transaction-bodyV2.js.map